import $ from 'jquery'
import { getAllFiles } from './getAllFiles'
import { getInputName } from './getInputName'

/**
 * @package     Image Hopper
 * @copyright   Copyright (c) 2021, Image Hopper
 * @license     http://opensource.org/licenses/gpl-2.0.php GNU Public License
 */

export function setUploadedFiles (fieldId, files, formId) {
  const allFiles = getAllFiles(formId)
  const $uploadedFiles = $('#gform_uploaded_files_' + formId)
  const inputName = getInputName(fieldId)

  allFiles[inputName] = files
  $uploadedFiles.val($.toJSON(allFiles))
}
